interface Props {
  className?: string;
}

const Checkmark: React.FC<Props> = ({ className }) => (
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M9.76764 0.482287C9.45824 0.172473 8.95582 0.172669 8.646 0.482287L3.59787 5.53062L1.35419 3.28696C1.04438 2.97715 0.542174 2.97715 0.23236 3.28696C-0.0774534 3.59677 -0.0774534 4.09897 0.23236 4.40879L3.03684 7.21327C3.19165 7.36807 3.39464 7.44567 3.59765 7.44567C3.80067 7.44567 4.00386 7.36827 4.15867 7.21327L9.76764 1.6041C10.0775 1.2945 10.0775 0.792081 9.76764 0.482287Z"
      fill="currentColor"
    />
  </svg>
);

export default Checkmark;
